module.exports = __webpack_public_path__ + "static/img/error_2.b78b96f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/error_2.png
// module id = Zwdl
// module chunks = 1